// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_SEO_LABELS = 'global.seo';

export const GlobalSeoLabels = {
  global: {
    seo: {
      lbl_account_TCP_description: `Manage your The children's place account and find all of the information on My Place Rewards, all in one place.`,
      lbl_account_GYM_description: `Manage your Gymboree account and find all of the information on My Place Rewards, all in one place.`,
      lbl_account_TCP_pageTitle: `Account Overview | The children's place`,
      lbl_account_GYM_pageTitle: `Account Overview | Gymboree`,
      lbl_bag_TCP_pageTitle: `Shopping Bag | The children's place`,
      lbl_bag_GYM_pageTitle: `Shopping Bag | Gymboree`,
      lbl_bag_TCP_description: `View your The children's place shopping bag and shop our selection of hand-me-down quality kids clothes, toddler clothes & baby clothes.`,
      lbl_bag_GYM_description: `View your Gymboree shopping bag and shop our selection of hand-me-down quality kids clothes, toddler clothes & baby clothes.`,
      lbl_checkout_TCP_pageTitle: `Checkout | The children's place`,
      lbl_checkout_GYM_pageTitle: `Checkout | Gymboree`,
      lbl_checkout_TCP_description: `Checkout and purchase quality kids clothes, toddler clothes and baby clothes from The children's place.`,
      lbl_checkout_GYM_description: `Checkout and purchase quality kids clothes, toddler clothes and baby clothes from Gymboree.`,
    },
  },
};
